export default __webpack_public_path__ + "static/media/gnosisSafe.ac694b37.svg";